// extracted by mini-css-extract-plugin
export default {"messageContainer":"Notifications_messageContainer__HsZh4","dash":"Notifications_dash__m0x9r"};